/**
 * PlatformAdminGuard
 *
 * Route-level guard that shows the standard "not authorized" lock banner
 * when the current user is not a platform admin. Used to protect routes
 * under /platform-admin from direct URL access by non-admins.
 */

import React, { type ReactNode } from 'react'
import { useCanAccess } from '../../hooks/useCanAccess'
import { UnauthorizedBanner } from './UnauthorizedBanner'

interface PlatformAdminGuardProps {
  children: ReactNode
}

export const PlatformAdminGuard: React.FC<PlatformAdminGuardProps> = ({ children }) => {
  const { isPlatformAdmin, isFlagEnabled, isLoading } = useCanAccess()
  if (isLoading) return null
  if (!isPlatformAdmin || !isFlagEnabled('platform_admin_view')) return <UnauthorizedBanner />
  return <>{children}</>
}

export default PlatformAdminGuard
